import React from 'react';

import Skeleton from '@atlaskit/avatar/skeleton';

const AvatarSkeletonWeightStrongExample = (): React.JSX.Element => {
	return <Skeleton color="#FF8B00" weight="strong" />;
};

export default AvatarSkeletonWeightStrongExample;
